import {processSectionValidations} from '@/engine/processor/validation';
import {Section, ValueDefinition} from '@/model/types';
import {buildDependencyGraph, createDependencyRegistrer} from '../dependencies';
import {DependencyMap, AccessMap, ModelSection, SectionAccessRecord} from '../types';
import {createConditionFactory} from './condition';
import {createEventHandler} from './event';
import {computeTitle} from './factories';
import {mapToModelGroup} from './group';

export const mapToModelSection = (
  section: Section,
  values: ValueDefinition[],
  dependencyMap: DependencyMap,
  accessMap: AccessMap,
): ModelSection => {
  const {title, hidden, displayIf, validations, groups, onMount, onSubmit, ...rest} = section;

  const dependencyRegistrer = createDependencyRegistrer(dependencyMap, section.id);

  const mappedSection = {
    ...rest,
    title: computeTitle(title, dependencyRegistrer),
    hidden: hidden ?? false,
    displayWith: section.displayWith ?? [],
    displayIf: displayIf
      ? displayIf.map(condition => createConditionFactory(condition, dependencyRegistrer, 'visibility'))
      : [() => () => true],
    validations: processSectionValidations(section.validations ?? [], dependencyRegistrer),
    onSubmit: (onSubmit ?? []).map(event => createEventHandler(event, dependencyRegistrer)),
    onMount: (onMount ?? []).map(event => createEventHandler(event, dependencyRegistrer)),
    groups: groups.map((group, groupIndex) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const sectionIndex = (accessMap.get(section.id)! as SectionAccessRecord).sectionIndex;
      accessMap.set(group.id, {sectionIndex, groupIndex});
      return mapToModelGroup(section.id, group, values, dependencyMap, accessMap);
    }),
  };

  buildDependencyGraph(
    dependencyMap,
    section.id,
    displayIf?.length ? groups.flatMap(group => [group.id, ...group.fields.map(field => field.id)]) : [],
  );

  return mappedSection;
};
